import type { AssetGroupId } from '@infinex/asset-config';

export function getInxOptionExerciseAssetGroupId(options?: {
  useToAsset?: boolean;
}): AssetGroupId {
  return options?.useToAsset
    ? {
        assetId: 'infinex',
      }
    : {
        assetId: 'usd_coin',
      };
}
